module.exports = __webpack_public_path__ + "img/newyear_reel.78741773.png";